






























export var OptionsAlignmentTypes;(function (OptionsAlignmentTypes) {OptionsAlignmentTypes["TOP_LEFT"] = "topLeft";OptionsAlignmentTypes["TOP_RIGHT"] = "topRight";OptionsAlignmentTypes["BOTTOM_LEFT"] = "bottomLeft";OptionsAlignmentTypes["BOTTOM_RIGHT"] = "bottomRight";})(OptionsAlignmentTypes || (OptionsAlignmentTypes = {}));
//# sourceMappingURL=Dropdown.js.map